import styled from "styled-components";

export const Cabecalho = styled.section`
  height: 2em;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.header.text};
`

export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: 60px 1fr;
  position: relative;
`;

export const SecaoButao = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  z-index: 3;
`

export const SubSecaoButao = styled.section`
  display: flex;
  gap: 0.5em;
`

export const ButtonDiv = styled.button`
  height: 2.7em;
  width: 7em;
  border-radius: 5px;
  border: none;
  font-size: 12px;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    background-color: rgb(200, 200, 200);
    transform: translateY(-2px);
  }
`

export const SectionSelectCargo = styled.div`
  display: flex;
  border-radius: 2px;
  margin: 5px;
  padding: 2px;
  gap: 5px;
  border-bottom: 1px solid #ccc;

  &:hover {
    background-color: #ccc;
  }
`

export const TabelaDetailsContainer = styled.div`
  overflow-y: auto;
  overflow-x: auto;
  padding: 5px;
  position: relative;
`

export const Checkbox = styled.input`
  background-color: #F1F4F9;
  width: 2em;
`

export const Icone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover{
    fill: var(--backgroundColor)
  }
`

export const PesquisarContainer = styled.div`
  display: flex;
`

export const PesquisarSection = styled.section`
  display: flex;
  margin-right: 10px;
`

export const SectionExportarTudo = styled.section`
  width: 3px;
  height: 3em;
  margin-top: 0.5em;
  border-radius: 5px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2em;

`
export const PaginacaoContainer = styled.section`
  display: flex;
  position: absolute;
  bottom: 5px;
  justify-content: space-around;
`

export const PaginacaoPointer = styled.div`
  position: relative;
`

export const ConfigureContainer = styled.div`
  background-color: #ccc;
  box-shadow: 1px 3px 2px rgba(0,0,0,0.3);
  width: 18em;
  top: -4em;
  left: -18em;
  height: 3em;
  margin-top: 0.5em;
  border-radius: 5px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2em;

  input {
    padding: 2px ;
    outline: none;
    border: 1px solid #f6f6f6;
    border-radius: 2px;
  }

  button {
    padding: 2px;
    border: 1px solid #f6f6f6;
    border-radius: 2px;
  }
`

export const ChangeConfigures = styled.div`
  cursor: pointer;
  height: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3em;
`
